module.exports = __webpack_public_path__ + "static/2-2285166ce917a46471598f5d9eb74b54.jpg";